export const environment = {
  production: false,
  apiBaseUrl: 'https://findmybus-api.dev.snapper.co.nz',
  heartbeatMaxDelayMinutes: 15
};

//Service provider for all Restful web services

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { StateService } from 'src/app/Service/state-service.service';
import { StateServiceHttp } from 'src/app/Service/state-service-http.service';

@Injectable()
export class ServiceProvider {
  constructor(
    private router: Router,
    private http: HttpClient
  ) {}

  getService(): StateService {
    return new StateServiceHttp(this.http);
  }
}
